
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class BottomBtnGroup extends Vue {
  @Prop({ default: false }) loading!: boolean;
  @Prop({ type: String, default: "立即发起" }) submitText!: string;
  @Prop({ type: Boolean, default: false }) draftDisabled!: boolean;

  draftIcon = require("@/assets/images/jielong/draft.png");
  previewIcon = require("@/assets/images/jielong/preview.png");

  /** 安卓键盘弹起时隐藏底部栏，避免被顶到输入框上方 */
  keyboardUp = false;
  private baseViewportHeight = 0;
  private onViewportChange: (() => void) | null = null;

  mounted (): void {
    // platform: '1' 安卓 / '2' iOS；iOS 多为键盘覆盖不压缩视口，无需处理
    if (window.platform !== "1") return;
    this.baseViewportHeight = window.innerHeight;
    this.onViewportChange = () => {
      const h = window.visualViewport?.height ?? window.innerHeight;
      if (h > this.baseViewportHeight) {
        this.baseViewportHeight = h;
      }
      this.keyboardUp = this.baseViewportHeight - h > 80;
    };
    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", this.onViewportChange);
    } else {
      window.addEventListener("resize", this.onViewportChange);
    }
  }

  beforeDestroy (): void {
    if (!this.onViewportChange) return;
    if (window.visualViewport) {
      window.visualViewport.removeEventListener("resize", this.onViewportChange);
    } else {
      window.removeEventListener("resize", this.onViewportChange);
    }
  }

  onDraftClick (): void {
    if (this.draftDisabled) return;
    this.$emit("draft");
  }
}
